import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import {
  useGetRoleQuery,
  useRenameRoleMutation,
  useAssignRolePermissionMutation,
  useRemoveRolePermissionMutation,
} from "../rolesApi";
import { useGetPermissionsQuery } from "../../admin/adminApi";
import PermissionChecklist from "../../../components/common/PermissionChecklist";

const RoleEditModal = ({ roleId, onClose }) => {
  const show = Boolean(roleId);
  const { data, isFetching } = useGetRoleQuery(roleId, { skip: !roleId });
  const { data: allPermissions = [] } = useGetPermissionsQuery();
  const [renameRole, { isLoading: isRenaming }] = useRenameRoleMutation();
  const [assignPermission] = useAssignRolePermissionMutation();
  const [removePermission] = useRemoveRolePermissionMutation();
  const [roleName, setRoleName] = useState("");

  useEffect(() => {
    setRoleName(data?.role?.roleName || "");
  }, [data]);

  const handleSaveName = async () => {
    if (!roleName.trim() || roleName === data?.role?.roleName) return;
    try {
      await renameRole({ roleId, roleName: roleName.trim() }).unwrap();
      toast.success("Role renamed");
    } catch (error) {
      toast.error(error?.message || "Could not rename role");
    }
  };

  const handleTogglePermission = async (permissionId, checked) => {
    try {
      if (checked) {
        await assignPermission({ roleId, permissionId }).unwrap();
      } else {
        await removePermission({ roleId, permissionId }).unwrap();
      }
    } catch (error) {
      toast.error(error?.message || "Could not update permission");
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {data?.role?.roleCode ? `Edit Role · ${data.role.roleCode}` : "Edit Role"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isFetching && !data ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="mb-4">
              <label className="form-label">Role Name</label>
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control"
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                  onBlur={handleSaveName}
                />
                <Button
                  variant="outline-primary"
                  onClick={handleSaveName}
                  disabled={isRenaming || roleName === data?.role?.roleName}
                >
                  Save
                </Button>
              </div>
              {data?.role?.grantsAllBranchAccess && (
                <span className="badge badge-linesuccess mt-2">
                  Grants all-branch access
                </span>
              )}
            </div>

            <h6 className="mb-3">Permissions</h6>
            <PermissionChecklist
              permissions={allPermissions}
              selectedIds={(data?.permissions || []).map(
                (p) => p.permissionId
              )}
              onToggle={handleTogglePermission}
            />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleEditModal;
